import { render, staticRenderFns } from "./prefix.vue?vue&type=template&id=f7ffa036&scoped=true&"
import script from "./prefix.vue?vue&type=script&lang=js&"
export * from "./prefix.vue?vue&type=script&lang=js&"
import style0 from "./prefix.vue?vue&type=style&index=0&id=f7ffa036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ffa036",
  null
  
)

export default component.exports